module.exports = __webpack_public_path__ + "static/media/bird1.184807e9.jpg";